import { graphql } from '@/gql';
import type { TipGroceryMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const tipGrocery = async ({ orderId, amount, notes }: TipGroceryMutationVariables) => {
  const response = await mutationExecute({
    variables: {
      orderId,
      amount,
      notes,
    },
    mutation: graphql(`
      mutation TipGrocery($orderId: String!, $amount: Float!, $notes: String!) {
        tipGrocery(orderId: $orderId, amount: $amount, notes: $notes)
      }
    `),
  });

  return response.data?.tipGrocery ?? false;
};
